module.exports = __webpack_public_path__ + "media/images/arrow21-cab858ef.svg";